import createIcon from '../../createIcon';

/**
 * @component @name PermContactCalendar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEgxOFYySDE2VjRIOFYySDZWNEg1QzMuODkgNCAzIDQuOSAzIDZWMjBDMyAyMS4xIDMuODkgMjIgNSAyMkgxOUMyMC4xIDIyIDIxIDIxLjEgMjEgMjBWNkMyMSA0LjkgMjAuMSA0IDE5IDRaTTEyIDdDMTMuNjYgNyAxNSA4LjM0IDE1IDEwQzE1IDExLjY2IDEzLjY2IDEzIDEyIDEzQzEwLjM0IDEzIDkgMTEuNjYgOSAxMEM5IDguMzQgMTAuMzQgNyAxMiA3Wk0xOCAxOUg2VjE4QzYgMTYgMTAgMTQuOSAxMiAxNC45QzE0IDE0LjkgMTggMTYgMTggMThWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermContactCalendar = createIcon('PermContactCalendar', [
  [
    'path',
    {
      d: 'M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM18 19H6V18C6 16 10 14.9 12 14.9C14 14.9 18 16 18 18V19Z',
      key: '1h2tgo',
    },
  ],
]);

export default PermContactCalendar;
